export const DEFAULT_STARGATE_SERVICE_URL = '/gateway/api';
export const PERMS_URL = '/permissions/permitted';
export const BULK_INVITE_URL = '/invitations/invite';
export const BULK_INVITE_URL_V3 = '/v3/invitations/invite';
export const INVITE_CAPABILITIES = '/v3/invitations/capabilities';
export const EXUS_THIRDPARTY_PATH = '/external-users/third-party';
export const OPEN_INVITE_URL = '/invitations/v1/settings/open-invite';
export const PERSONALIZATION_URL = '/gateway/api/tap-delivery/api/v3/personalization';
export const DIRECT_ACCESS_URL = '/invitations/v1/settings/domain-enabled-signup-promotion';
export const HAVE_I_SEEN_IT_URL = '/flag/my';
export const EXUS_ORGS_PATH = '/external-users/orgs';
export const BILLING_API_GATEWAY_URL = `${DEFAULT_STARGATE_SERVICE_URL}/bag`;
export const ELIGIBLE_USERS = '/growth/ci-funnel-improvement/get-eligible-users';
export const GRAPHQL_GATEWAY_URL = '/graphql';

export const getOpenInviteNoteUrl = (stargateUrl: string, orgId: string) =>
	`${stargateUrl}/invitations/v1/access-settings/org/${orgId}/open-invite/note`;
